import styled from 'styled-components';
import DisabledMenuItem from './DisabledMenuItem';

export default styled(DisabledMenuItem)`
    font-style: italic;
`;
